import React from "react";
import ShareWithDetails from "../../../SharedWith/SharedWithDetails/SharedWithDetails";
import { useHistory } from "react-router-dom";
import { getIntials, getName, getParsedTime } from "../../../../helper";
import { getDocument } from "../../../../container/Feed/Feed";
import AddActivityItem from "./AddActivityItem/AddActivityItem";
import UpdateActivityItem from "./UpdateActivityItem/UpdateActivityItem";
import SharedActivityItem from "./SharedActivityItem/SharedActivityItem";
import DeleteActivityItem from "./DeleteActivityItem/DeleteActivityItem";
import ArchiveActivityItem from "./ArchiveActivityItem/ArchiveActivityItem";
import MoveActivityItem from "./MoveActivityItem/MoveActivityItem";
import CommentActivityItem from "./CommentActivityItem/CommentActivityItem";
import { markActivitiesAsRead } from "../Activities";
import activityDotImage from "../../../../assets/icons/activity-dot.svg";

// Styles
import "./Activity.scss";
import ReactTooltip from "react-tooltip";

const ACTIVITY_TYPES = {
  ADDED: "Added",
  UPDATED: "Updated",
  DELETED: "Deleted",
  SHARED: "Shared",
  ARCHIVED: "Archived",
  MOVED: "Moved",
  COMMENTED: "Commented",
  REPLIED: "Replied",
  MENTIONED: "Mentioned",
};

const Activity = ({
  activity,
  isAllActivityRead,
  handleDocumentView = () => {},
  currentUserInfo,
  setNewActivitiesCount,
}) => {
  const [isRead, setIsRead] = React.useState(activity.isRead);
  const history = useHistory();

  const markActivityAsRead = async () => {
    const result = await markActivitiesAsRead({
      feedIds: [activity.id],
    });
    if (result.data.markAsRead.success) {
      setIsRead(true);
      setNewActivitiesCount((count) => count - 1);
    }
  };

  const openDocument = async (documentId, isComment = false) => {
    const document = await getDocument(documentId);
    if (document) {
      //First mark activity as read if not read
      if (!isAllActivityRead && !isRead) {
        markActivityAsRead();
      }

      handleDocumentView(document, isComment);
    }
  };

  const openFolder = (folder) => {
    const routingPath = folder.isRoot
      ? !folder.isArchive
        ? `/files/${folder.id}`
        : `/archives/${folder.id}`
      : !folder.isArchive
      ? `/files/${folder.parentFolder.id}/${folder.id}`
      : `/archives/${folder.parentFolder.id}/${folder.id}`;

    //First mark activity as read
    markActivityAsRead();

    history.push(routingPath);
  };

  const getActivityString = ({
    feedActivity,
    isDocument,
    document,
    isFolder,
    folder,
    previousFolder,
    isNewField,
    isSubFile,
    subFile,
    comment,
    isComment,
    isReply,
    isMention,
    hasAccess,
  }) => {
    switch (feedActivity.name) {
      case ACTIVITY_TYPES.ADDED:
        return <AddActivityItem {...{ onClick: openDocument, isDocument, document, isSubFile, subFile, hasAccess }} />;
      case ACTIVITY_TYPES.UPDATED:
        return (
          <UpdateActivityItem
            {...{
              onClick: openDocument,
              document: document,
              isNewField,
              isSubFile,
              subFile,
              hasAccess,
            }}
          />
        );
      case ACTIVITY_TYPES.SHARED:
        return (
          <SharedActivityItem {...{ openDocument, openFolder, isDocument, document, isFolder, folder, hasAccess }} />
        );
      case ACTIVITY_TYPES.DELETED:
        return (
          <DeleteActivityItem
            {...{ isDocument, document, isFolder, folder, isSubFile, subFile, openDocument, openFolder, hasAccess }}
          />
        );
      case ACTIVITY_TYPES.ARCHIVED:
        return (
          <ArchiveActivityItem {...{ isDocument, document, isFolder, folder, openDocument, openFolder, hasAccess }} />
        );
      case ACTIVITY_TYPES.MOVED:
        return (
          <MoveActivityItem
            {...{ isDocument, document, isFolder, folder: folder, openFolder, previousFolder, hasAccess }}
          />
        );
      case ACTIVITY_TYPES.COMMENTED:
      case ACTIVITY_TYPES.MENTIONED:
      case ACTIVITY_TYPES.REPLIED:
        return <CommentActivityItem {...{ openDocument, document, comment, isComment, isMention, isReply, currentUserInfo }} />;
      default:
        break;
    }
  };

  const user = {
    ...activity.createdBy,
    name: getName(activity.createdBy),
    nameIntial: getIntials(activity.createdBy),
  };

  return (
    <div className="activity-item">
      <div className="activity-item-main-section">
        <ShareWithDetails
          key={activity.id}
          sKey={activity.id}
          isPopover={true}
          nameIntial={user.nameIntial}
          personName={user.name}
          profile={user.profile.image}
          email={user.email}
          isFromActivity={true}
        />
        <span className="activity-item-main">
          <span className="activity-item-username">{user.name}</span>
          <span className="activity-item-activity-string">{getActivityString(activity)}</span>
        </span>
      </div>
      <div className="activity-item-time-section">
        <span className={`${!activity.isRead ? `activity-item-time-section-unread` : ""}`}></span>
        {getParsedTime(activity.createdTs)}

        <ReactTooltip id={activity.id} place="top" effect="solid">
          Mark As Read
        </ReactTooltip>
        <span className="activity-item-dot" onClick={markActivityAsRead}>
          {!isAllActivityRead && !isRead ? (
            <img
              className="activity-item-dot-image"
              src={activityDotImage}
              alt="Mark read"
              data-tip
              data-for={activity.id}
            />
          ) : null}
        </span>
      </div>
    </div>
  );
};

export default Activity;
